// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".styles-module__profileContainer___iL1Go {\n  max-width: 45rem;\n  margin: 0 auto;\n}\n", "",{"version":3,"sources":["webpack://screens/business-profile-page/components/preview-profile-page/styles.module.less"],"names":[],"mappings":"AAAA;EACE,gBAAA;EACA,cAAA;AACF","sourcesContent":[".profileContainer {\n  max-width: 45rem;\n  margin: 0 auto;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"profileContainer": "styles-module__profileContainer___iL1Go"
};
export default ___CSS_LOADER_EXPORT___;
